import React from 'react';

import { ErrorMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import { CardRegion, Piwik, RegionWarning } from '../../types';

interface WarningDisplayProps {
    region: CardRegion;
    warning: RegionWarning | null;
    piwik: Piwik | undefined;
}

export default ({ region, warning, piwik }: WarningDisplayProps) => {
    if (warning && warning.region.id === region.id) {
        return (
            <div
                className="warning-container"
                data-track-id={piwik?.regionBlockEcommerce?.regionBlockRegionWarning?.dataTrackId}
                data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockRegionWarning?.dataTrackLinkname}
                id={piwik?.regionBlockEcommerce?.regionBlockRegionWarning?.dataTrackId}
            >
                <ErrorMessage id={warning.warningMessage} text={warning.warningMessage} icon={IconTypes.LUKK_24} />
            </div>
        );
    }

    return null;
};
